const PERMISSION_KEY= "core:membership_plan_user";
const PAGE_URL = {
    MEMBERSHIP_PLAN_USER_PAGE: "/admin/core/membership-plan-user"
}

export {PERMISSION_KEY, PAGE_URL}

